module.exports = __webpack_public_path__ + "i18n/ru_8bf2cbb1d8e3c18210eee8ebc18558da.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 153